import Dialog from '~/domains/design-system/components/Dialog/Dialog';

import { REFER_AMOUNT } from '../consts';
import { RAFDrawer } from './RAFDrawer';
import { Box, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  modal: {
    zIndex: 9999,
  },
}));

type RAFModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isClosing?: boolean;
  isCloseDisabled?: boolean;
};

function RAFModal({ isOpen, isClosing, onClose, isCloseDisabled }: RAFModalProps) {
  const { classes } = useStyles();
  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      isOpen={isOpen}
      isClosing={isClosing}
      onClose={isCloseDisabled ? undefined : onClose}
      className={classes.modal}
    >
      <Box /* eslint-disable-line local-rules/use-theme-tokens */ p={24}>
        <RAFDrawer amount={REFER_AMOUNT} onClose={onClose} />
      </Box>
    </Dialog>
  );
}

export default RAFModal;
